export const E_TypesReports = {
  simple: 'simple',
}